module.exports = __webpack_public_path__ + "img/trio.ad088b23.png";